'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dApp$002dRouter$0024$002dImport$002dRecipes$002dApp$002dPage from "./mealorama.-App-Router$-Import-Recipes-App-Page.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$ImportRecipesAppPage$() {
}
export { $c_Lmealorama_AppRouter$ImportRecipesAppPage$ as $c_Lmealorama_AppRouter$ImportRecipesAppPage$ };
$p = $c_Lmealorama_AppRouter$ImportRecipesAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$ImportRecipesAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$ImportRecipesAppPage$() {
}
export { $h_Lmealorama_AppRouter$ImportRecipesAppPage$ as $h_Lmealorama_AppRouter$ImportRecipesAppPage$ };
$h_Lmealorama_AppRouter$ImportRecipesAppPage$.prototype = $p;
$p.m = (function() {
  return "ImportRecipesAppPage";
});
$p.aS4 = (function(x$0) {
  return new $j_mealorama$002e$002dApp$002dRouter$0024$002dImport$002dRecipes$002dApp$002dPage.$c_Lmealorama_AppRouter$ImportRecipesAppPage(x$0.g(0));
});
var $d_Lmealorama_AppRouter$ImportRecipesAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$ImportRecipesAppPage$, "mealorama.AppRouter$ImportRecipesAppPage$", ({
  Fr: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AppRouter$ImportRecipesAppPage$ as $d_Lmealorama_AppRouter$ImportRecipesAppPage$ };
var $n_Lmealorama_AppRouter$ImportRecipesAppPage$;
function $m_Lmealorama_AppRouter$ImportRecipesAppPage$() {
  if ((!$n_Lmealorama_AppRouter$ImportRecipesAppPage$)) {
    $n_Lmealorama_AppRouter$ImportRecipesAppPage$ = new $c_Lmealorama_AppRouter$ImportRecipesAppPage$();
  }
  return $n_Lmealorama_AppRouter$ImportRecipesAppPage$;
}
export { $m_Lmealorama_AppRouter$ImportRecipesAppPage$ as $m_Lmealorama_AppRouter$ImportRecipesAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Import-Recipes-App-Page$.js.map
